/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { SnackbarProvider } from 'notistack';
import { CustomSwitch, CustomTable } from '@/components';
import useStyle from './useStyle';
import DivImage from '../tableStyle';

const CategoriesPaymentTable = (props) => {
  const classes = useStyle();
  const { categoriesData } = props;
  const [categoriesRows, setCategoriesRows] = React.useState([]);
  const providerRef = React.useRef();

  function createActions() {
    return (
      <Box display="flex" flexDirection="row" justifyContent="center">
        <IconButton
          edge="end"
          aria-label="Editar"
          size="small"
          classes={{ disabled: classes.disabled }}
          disabled
        >
          <Tooltip title="Editar" aria-label="edit" placement="top">
            <EditIcon className={classes.editIcon} />
          </Tooltip>
        </IconButton>
        <IconButton
          edge="end"
          aria-label="Delete"
          size="small"
          disabled
          style={{ paddingLeft: 10 }}
          classes={{ disabled: classes.disabled }}
        >
          <Tooltip title="Eliminar" aria-label="delete" placement="top">
            <DeleteIcon className={classes.editIcon} />
          </Tooltip>
        </IconButton>
      </Box>
    );
  }

  const createStatusSwitch = (categoryParam) => (
    <Tooltip title="Cambiar estado" aria-label="changeState" placement="top">
      <Box alignSelf="center">
        <CustomSwitch
          checked={categoryParam.status}
          name="active"
          disabled
        />
      </Box>
    </Tooltip>
  );

  function createImage(url) {
    return (
      <DivImage url={url}>
        {url && <img src={url} alt="" />}
      </DivImage>
    );
  }

  const mapCodes = async (categoriesParam) => {
    let categoryInfo = [];
    if (categoriesParam) {
      categoryInfo = categoriesParam.filter((category) => category.categoryType === 'Pagos' || category.categoryType === 'PagosRecargas').map((category) => ({
        id: category.categoryId,
        name: category.creditorAgent,
        order: category.orderId,
        icon: createImage(category.categoryIdUrlImg),
        actions: createActions(),
        state: createStatusSwitch(category),
        vendor: category.vendor,
        active: 1,
      }));
    }
    setCategoriesRows(categoryInfo);
  };

  useEffect(() => {
    async function fetchData() {
      await mapCodes(categoriesData);
    }
    fetchData();
  }, [categoriesData]);

  const columns = [
    {
      id: 'name', label: 'Nombre', paddingLeft: '40px', width: 150, position: 1,
    },
    {
      id: 'icon', label: 'Icono', paddingLeft: '40px', width: 150, position: 2,
    },
    {
      id: 'order', label: 'Orden', paddingLeft: '40px', width: 150, position: 3,
    },
    {
      id: 'vendor', label: 'Facturador', paddingLeft: '40px', width: 150, position: 3,
    },
    {
      id: 'actions',
      paddingLeft: '',
      label: 'Acciones',
      width: 5,
      position: 4,
    },
    {
      id: 'state',
      paddingLeft: '',
      label: 'Estado',
      width: 5,
      position: 5,
    },
  ];

  return (
    <SnackbarProvider ref={providerRef}>
      <CustomTable
        data={categoriesRows}
        columns={columns}
        readOnly
      />
    </SnackbarProvider>
  );
};

export default CategoriesPaymentTable;
